import { orgPackages, orgPackagesCount } from '../../../api/supportAdmin';
import errorHandle from '../../../utils/errorHandle';

export const FetchPackList = async (
    setTripData,
    orgId,
    selectedStatus,
    limit,
    offset,
    datesType,
    group,
    setLoading,
    serviceType,
    searchRe
) => {
    setLoading(true);
    try {
        const res = await orgPackages(orgId, selectedStatus, limit, offset, datesType, group, serviceType, searchRe);
        setTripData(res);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const countOfPackages = async (
    setTotalCount,
    orgId,
    selectedStatus,
    datesType,
    group,
    setLoading,
    serviceType,
    searchRe
) => {
    setLoading(true);
    try {
        const res = await orgPackagesCount(orgId, selectedStatus, datesType, group, serviceType, searchRe);
        setTotalCount(res.data.packCount);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};
